var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useAppSelector } from "@/hooks/store";
import { useGetModuleListQuery, useSaveDashletPreferencesMutation, useSaveRecordMutation, } from "@/store/api";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import { faClose, faChevronDown, faChevronUp, } from "@fortawesome/pro-solid-svg-icons";
import { Pagination } from "@/components/dev/pagination";
import { LoaderImage } from "@/utils/loader";
import { useNavigate } from "react-router-dom";
import { DashletContext } from "../dashboard";
import { Activity } from "./activity";
import Input from "@mui/joy/Input";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
/**
 * <b>Composants de rendu de dashlet liste</b>
 *
 * @param param0
 */
function MessageDashlet(_a) {
    var _this = this;
    var _b;
    var widget = _a.widget;
    var currentUser = useAppSelector(getCurrentUser) || {};
    var t = useTranslation([
        "common",
        "Administration",
        "Home",
        widget === null || widget === void 0 ? void 0 : widget.payload.module,
    ]).t;
    // Get Dashlet Context
    var _c = useContext(DashletContext), settings = _c.settings, editedSettings = _c.editedSettings;
    var _d = useState([]), records = _d[0], setRecords = _d[1];
    var _e = useState(5), pageSize = _e[0], setPageSize = _e[1];
    var navigate = useNavigate();
    var _f = useState([
        {
            name: "date_modified",
            direction: "descending",
        },
    ]), sortedParams = _f[0], setSortedParams = _f[1];
    var _g = useState(0), currentPage = _g[0], setCurrentPage = _g[1];
    var module = widget === null || widget === void 0 ? void 0 : widget.payload.module;
    var title = (widget === null || widget === void 0 ? void 0 : widget.payload.title) || module;
    var displayRows = (widget === null || widget === void 0 ? void 0 : widget.payload.displayRows) || 3;
    var refreshValue = (widget === null || widget === void 0 ? void 0 : widget.payload.refresh) || -1;
    var id = (widget === null || widget === void 0 ? void 0 : widget.payload.id) || "";
    var allDashlets = (widget === null || widget === void 0 ? void 0 : widget.payload.allDashlets) || [];
    var defaultRules = [
        {
            field: "deleted",
            operator: "eq",
            value: 0,
        },
        {
            field: "related_module",
            operator: "neq",
            value: "SugarFeed",
        },
    ];
    var _h = useState(defaultRules), rules = _h[0], setRules = _h[1];
    var whereRule = [
        {
            operator: "and",
            rules: rules,
        },
    ];
    useEffect(function () {
        setRules(defaultRules);
    }, []);
    // Get result
    var _j = useGetModuleListQuery({
        table: module,
        params: {
            sorted: sortedParams,
            where: whereRule,
            page: currentPage,
            pageSize: displayRows || pageSize,
            count: false,
        },
    }), recordResponse = _j.data, isLoading = _j.isLoading, isSuccess = _j.isSuccess, refetch = _j.refetch;
    // Count result
    var recordCount = useGetModuleListQuery({
        table: module,
        params: {
            where: whereRule,
            page: 0,
            pageSize: -1,
            count_only: true,
        },
    }).data;
    var _k = useState(0), totalRecord = _k[0], setTotalRecord = _k[1];
    var _l = useState(false), addExtraParam = _l[0], setExtraParam = _l[1];
    useMemo(function () {
        var _a;
        var totalRecord = ((_a = recordCount === null || recordCount === void 0 ? void 0 : recordCount.data) === null || _a === void 0 ? void 0 : _a.total_count) || 0;
        setTotalRecord(totalRecord);
    }, [recordCount]);
    var allRecord = useMemo(function () {
        var _a;
        // Grid data
        var recordData = ((_a = recordResponse === null || recordResponse === void 0 ? void 0 : recordResponse.data) === null || _a === void 0 ? void 0 : _a.records) || [];
        setRecords(recordData);
    }, [recordResponse]);
    //console.log("ACTIVITY STREAM", recordResponse?.data?.records);
    // Event to change pagination
    var handlePagination = function (e) {
        var newPage = e.selected;
        if (newPage !== currentPage) {
            setCurrentPage(e.selected);
        }
    };
    var handleClick = function () {
        editedSettings(__assign(__assign({}, settings), { isSelected: true, module: module, id: id, title: title, dashlet: widget.payload }));
    };
    var _m = useSaveDashletPreferencesMutation(), saveDashletPreferences = _m[0], _o = _m[1], dashletLoad = _o.isLoading, isError = _o.isError, data = _o.data;
    var removeClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var newDashlets, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newDashlets = Object.values(allDashlets).filter(function (item) {
                        return item.id !== id;
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!window.confirm(String(t("LBL_REMOVE_DASHLET_CONFIRM", { ns: "Home" })))) return [3 /*break*/, 3];
                    return [4 /*yield*/, saveDashletPreferences({
                            dashlets: newDashlets,
                            isNew: false,
                        }).unwrap()];
                case 2:
                    result = _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Failed to save widgets:", error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (refreshValue && refreshValue !== -1) {
            var interval_1 = setInterval(function () {
                refetch();
                setCurrentPage(0);
            }, refreshValue);
            return function () { return clearInterval(interval_1); };
        }
    }, [records]);
    var activityName = function (activityString) {
        /*const test =
          "&lt;b&gt;{this.CREATED_BY}&lt;/b&gt; {SugarFeed.CREATED_LEAD} [Leads:c35e07ad-f4b2-bd20-c3a2-622efbe26357:Sébastien SAUVAGET]";*/
        var matches = activityString.match(/\{SugarFeed.CREATED_(.*)\}/);
        return (matches === null || matches === void 0 ? void 0 : matches[1]) ? matches === null || matches === void 0 ? void 0 : matches[1] : "";
    };
    var switchIcon = function () {
        setExtraParam(!addExtraParam);
    };
    var _p = useState(""), textMsg = _p[0], setTextMessage = _p[1];
    var handleTextChange = function (e) {
        var messageToPost = e.target.value;
        if (messageToPost) {
            setTextMessage(messageToPost);
        }
        else if (messageToPost === "") {
            setTextMessage("");
        }
    };
    var _q = useState(""), linkType = _q[0], setLinkType = _q[1];
    var handleLinkType = function (type) {
        var lnkType = type;
        if (lnkType) {
            setLinkType(lnkType);
        }
    };
    var _r = useState(""), linkUrl = _r[0], setLinkURL = _r[1];
    var handleLinkURL = function (e) {
        var linkURL = e.target.value;
        if (linkURL) {
            setLinkURL(linkURL);
        }
        else if (linkURL === "") {
            setLinkURL("");
        }
    };
    var _s = useSaveRecordMutation(), saveRecordMutation = _s[0], isLoadingSave = _s[1].isLoading;
    var _t = useState(false), onPost = _t[0], setOnPost = _t[1];
    var handlePostMessage = function () { return __awaiter(_this, void 0, void 0, function () {
        var record, result;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setOnPost(true);
                    record = {
                        module: "SugarFeed",
                        name: textMsg,
                        related_module: "UserFeed",
                        link_url: linkUrl ? linkUrl : null,
                        link_type: linkUrl ? linkType : null,
                        assigned_user_id: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) === null || _a === void 0 ? void 0 : _a.id,
                        related_id: (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) === null || _b === void 0 ? void 0 : _b.id,
                    };
                    return [4 /*yield*/, saveRecordMutation({
                            body: { module: "SugarFeed", record: record },
                        }).unwrap()];
                case 1:
                    result = _c.sent();
                    if (result) {
                        resetForm();
                        setOnPost(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setExtraParam(false);
        setTextMessage("");
        setLinkType("Link");
        setLinkURL("");
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ id: "grid", className: "m-2 dark:bg-[var(--colors-bg-default)] p-2 rounded-md shadow sm:p-4 relative grid-container" }, { children: [(isLoading || dashletLoad || onPost) && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "border-b-2 mb-4 flex flex-row justify-between" }, { children: [_jsx("h3", __assign({ className: "uppercase font-bold my-2" }, { children: title })), _jsxs("div", __assign({ className: "flex flex-row justify-end" }, { children: [_jsx(Pagination, { sizeClass: "smallSize", totalResult: totalRecord, elementPerPage: displayRows || pageSize, currentPage: currentPage, onChangePagination: function (event) { return handlePagination(event); } }), _jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: handleClick, title: String(t("app.LBL_EDIT_BUTTON", { ns: "common" })) }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: function () {
                                        setCurrentPage(0);
                                    }, title: String(t("LBL_RETURN", { ns: "Administration" })) }, { children: _jsx(FontAwesomeIcon, { icon: faRotateLeft, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-red-500 p-1 rounded-md", onClick: removeClick, title: String(t("app.LBL_REMOVE", { ns: "common" })) }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "text-gray-400 hover:text-white" }) }))] }))] })), _jsxs("div", { children: [_jsxs("div", __assign({ className: "border-b-2 clear\n          flex flex-col" }, { children: [_jsxs("div", __assign({ className: "flex flex-row" }, { children: [addExtraParam ? (_jsx("span", __assign({ className: "mr-2 mt-1", onClick: switchIcon }, { children: _jsx(FontAwesomeIcon, { icon: faChevronDown, className: "text-gray-400" }) }))) : (_jsx("span", __assign({ className: "mr-2 mt-1", onClick: switchIcon }, { children: _jsx(FontAwesomeIcon, { icon: faChevronUp, className: "text-gray-400" }) }))), _jsx("span", __assign({ className: "mr-2 mt-1 font-medium" }, { children: (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) === null || _b === void 0 ? void 0 : _b.full_name })), _jsx("span", __assign({ className: "w-full mb-4 mr-2" }, { children: _jsx(Input, { type: "text", value: textMsg, onChange: handleTextChange }) })), _jsx("button", __assign({ className: "w-1/5 mb-4 text-white end-2.5 bottom-2.5 bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-blue-800", onClick: handlePostMessage }, { children: "Poster" }))] })), addExtraParam && (_jsxs("div", __assign({ className: "flex flex-row" }, { children: [_jsx("span", __assign({ className: "mr-2" }, { children: _jsxs(Select, __assign({ defaultValue: linkType, value: linkType, onChange: function (event, value) {
                                                    handleLinkType(value);
                                                } }, { children: [_jsx(Option, __assign({ value: "Link" }, { children: "Lien" })), _jsx(Option, __assign({ value: "Image" }, { children: "Image" }))] })) })), _jsx("span", __assign({ className: "w-full mb-4" }, { children: _jsx(Input, { type: "text", value: linkUrl, onChange: handleLinkURL }) }))] })))] })), records &&
                            records.length > 0 &&
                            isSuccess &&
                            Object.values(records).map(function (record, index) { return (_jsx(_Fragment, { children: _jsx(Activity, { record: record }) })); })] })] })) }));
}
widgetsDictionary.register("widget/dashlet/activity-stream", {
    name: "Widget de dashboard de type flux d'activité",
    display: MessageDashlet,
});
